import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getQiwaContractData,
  getQiwaContractRenewData,
} from "../../../../../store/Api";
import { setAppError, setBreadCrumb } from "../../../../../store/userSlice";
import FileUploadElement from "../../../../../ReusableComponents/UploadFile/uplaodFile";
import ListQiwaContractRenewal from "./ListQiwaContractRenewal";
import nodeinstance from "../../../../../nodeInstance";

export default function QiwaContractRenewal() {
  const qiwa = useSelector((state) => state.qiwaDataRenew);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");
  const [searchWords, setSearchWords] = useState([]);

  // useEffect(() => {
  //   dispatch(getQiwaContractRenewData(token));
  // }, []);

  const [data, setData] = useState();
  const [searchData, setSearchData] = useState([]);

  const getData = async () => {
    try {
      const response = await nodeinstance.get(
        `/qiwaContract/getQiwaDataGR/${"RENEWGR"}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setData(response.data);
      }
    } catch (error) {
      console.log("error to be seen in console", error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const updateData = () => {
    // dispatch(getQiwaContractRenewData(token));
    getData();
  };
  console.log(
    "...Data to be printed in the console",
    searchWords && searchWords[0]
  );

  const getSearchData = async () => {
    try {
      const response = await nodeinstance.get(
        `/qiwaContract/getDataBySearch/${searchWords && searchWords[0]}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setSearchData(response.data);
      }
    } catch (error) {
      console.log("error to be printed in the console", error);
    }
  };
  useEffect(() => {
    if (searchWords && searchWords[0]?.length > 3){
      getSearchData();
    }
   
  },[searchWords])
  return (
    <>
      <div className={`p-2  sm:p-5 `}>
        <ListQiwaContractRenewal
          list={searchData?.data?.length > 0 ? searchData : data}
          loading={loading}
          titles={[
            "S.NO.",
            "EMPLOYEE ID",
            "EMPLOYEE NAME",
            "RELIGION",
            "NATIONALITY",
            "CURRENT SPONSOR",
            "CLIENT",
            "UPLOAD INSTANCE",
            "STATUS",
            "ACTION",
          ]}
          token={token}
          updateData={updateData}
          searchWords={searchWords}
          setSearchWords={setSearchWords}
        />
      </div>
    </>
  );
}
